module.exports = __webpack_public_path__ + "img/cocktail_250.02a06b27.webp";